import Marquee from "react-fast-marquee";
import { MARQUEE_ITEMS } from "../../data/site";

const EditorialMarquee = () => (
  <div className="border-y border-white/5 bg-surface py-5" data-testid="editorial-marquee">
    <Marquee speed={28} gradient={false} pauseOnHover>
      {MARQUEE_ITEMS.map((item, i) => (
        <span key={i} className="mx-8 flex items-center gap-8">
          <span className="font-serif-accent text-xl italic text-volt/70">{item}</span>
          <span className="text-white/20">•</span>
        </span>
      ))}
    </Marquee>
  </div>
);

export default EditorialMarquee;
